import React from 'react'
import { FormattedNumber } from 'react-intl'

const isInt = (num) => num % 1 === 0

type Props = {
  value: number
  round?: boolean
  currency: string
}

// Map currencies to their symbols/codes for display after the number
const currencySymbols = {
  USD: '$',
  AUD: 'A$',
  CAD: 'C$',
  NZD: 'NZ$',
  EUR: '€',
  GBP: '£',
  CHF: 'CHF',
  SEK: 'kr',
  DKK: 'kr',
  NOK: 'kr',
  BRL: 'R$',
  MXN: 'MX$',
  INR: '₹',
}

function FormattedCurrency({ value, round = false, currency }: Props) {
  // Special handling for Nordic currencies: round up when requested
  const processedValue =
    ['SEK', 'DKK', 'NOK'].includes(currency) && round ? Math.ceil(value) : value

  // Set decimal places based on whether value is integer
  const isInteger = isInt(processedValue)
  const minimumFractionDigits = isInteger ? 0 : 2
  const maximumFractionDigits = isInteger ? 0 : 2

  const currencySymbol = currencySymbols[currency] || currency

  // Format all currencies as "77 kr" / "77 $" / "77 €" for consistency
  return (
    <>
      <FormattedNumber
        value={processedValue}
        minimumFractionDigits={minimumFractionDigits}
        maximumFractionDigits={maximumFractionDigits}
      />
      {'\u00A0'}
      {currencySymbol}
    </>
  )
}

export default FormattedCurrency
